<template>
  <div>
    <h1 class="h2 mt-4 mb-3">Expiring Items</h1>
    <div v-if="expiringItems === null" class="alert alert-secondary font-italic" role="alert">
      Loading...
    </div>
    <ul class="list-group" v-else>
      <li class="list-group-item" v-if="expiringItems.length === 0">No Items Expiring Soon 🎉</li>
      <router-link
        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
        :to="{ name: 'product', params: { productId: item.productId } }"
        v-else
        v-for="(item, i) in expiringItems"
        :key="i"
      >
        <span>{{ item.brandName }} {{ item.label }}</span>
        <ExpiryDateBadge :expiryDate="item.expiryDate" />
      </router-link>
    </ul>
  </div>
</template>

<script>
import ExpiryDateBadge from '@/components/ExpiryDateBadge'

export default {
  components: { ExpiryDateBadge },
  computed: {
    expiringItems() {
      if (!this.$store.getters.isLoaded(['shelves', 'products'])) return null
      const expiringItems = []
      this.$store.state.shelves.forEach(shelf => {
        Object.keys(shelf.spaces).forEach(spaceId => {
          shelf.spaces[spaceId].items.forEach(item => {
            if (item.expiryDate) {
              const today = new Date().getTime()
              const expiryDate = new Date(item.expiryDate).getTime()
              const daysTillExpired = Math.ceil((expiryDate - today) / (1000 * 3600 * 24))
              const product = this.$store.state.products.find(p => p.id === item.productId)
              if (daysTillExpired < 30) {
                expiringItems.push({ ...item, ...product, daysTillExpired })
              }
            }
          })
        })
      })

      return _.sortBy(expiringItems, 'daysTillExpired')
    }
  }
}
</script>
